//获取url中参数
export default {
	getUrlKey: function(name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/urlParam.js